import { connect } from 'react-redux';
import { get } from 'lodash';

import ProductWarning from 'apps/fops/components/fopPartials/ProductWarning';

export default connect(
  (state, ownProps) => {
    const sku = get(ownProps, 'product.sku');

    if (!sku) {
      return null;
    }

    return {
      basketItem: state.basket.items.find(item => item.sku === sku),
      productWarningsForSku: state.basket.productWarnings[sku],
    };
  },
)(ProductWarning);
